module.exports = __webpack_public_path__ + "img/sjoelen.279ebf1e.jpeg";